module.exports = __webpack_public_path__ + "static/media/player_20p.ad35cf6b.png";